module.exports = __webpack_public_path__ + "static/media/planet_image.ed86e9b1.png";